import countryData from "../../../resources/json/countries.json";

const FLAG_BASE = "https://cdn.jsdelivr.net/npm/flag-icons@7.2.3/flags/4x3";

export const flagUrl = (code) =>
  code ? `${FLAG_BASE}/${String(code).toLowerCase()}.svg` : null;

const displayNamesCache = new Map();

const getDisplayNames = (language) => {
  const lang = String(language || "en")
    .slice(0, 2)
    .toLowerCase();
  if (!displayNamesCache.has(lang)) {
    let formatter = null;
    try {
      formatter =
        typeof Intl !== "undefined" && Intl.DisplayNames
          ? new Intl.DisplayNames([lang], { type: "region" })
          : null;
    } catch {
      formatter = null;
    }
    displayNamesCache.set(lang, formatter);
  }
  return displayNamesCache.get(lang);
};

const localisedName = (country, language) => {
  if (
    String(language || "en")
      .toLowerCase()
      .startsWith("en")
  ) {
    return country.name;
  }
  const formatter = getDisplayNames(language);
  try {
    const label = formatter?.of(country.code);
    return label && label !== country.code ? label : country.name;
  } catch {
    return country.name;
  }
};

const normalise = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

const optionsCache = new Map();

export const getCountryOptions = (language = "en") => {
  const lang = String(language || "en")
    .slice(0, 2)
    .toLowerCase();
  if (optionsCache.has(lang)) {
    return optionsCache.get(lang);
  }

  const collator = new Intl.Collator(lang, { sensitivity: "base" });
  const options = countryData
    .map((country) => {
      const label = localisedName(country, lang);
      const aliases = country.aliases || [];
      return {
        code: country.code,
        value: country.name,
        label,
        flag: flagUrl(country.code),
        searchText: normalise(
          [label, country.name, country.code, ...aliases].join(" "),
        ),
        aliases,
      };
    })
    .sort((a, b) => collator.compare(a.label, b.label));

  optionsCache.set(lang, options);
  return options;
};

export const filterCountryOptions = (options, query) => {
  const needle = normalise(query);
  if (!needle) {
    return options;
  }
  const startsWith = [];
  const contains = [];
  options.forEach((option) => {
    if (normalise(option.label).startsWith(needle)) {
      startsWith.push(option);
    } else if (option.searchText.includes(needle)) {
      contains.push(option);
    }
  });
  return [...startsWith, ...contains];
};

export const findCountryOption = (value, language = "en") => {
  const needle = normalise(value);
  if (!needle) {
    return null;
  }
  const options = getCountryOptions(language);
  return (
    options.find(
      (option) =>
        normalise(option.value) === needle ||
        normalise(option.code) === needle ||
        normalise(option.label) === needle ||
        option.aliases.some((alias) => normalise(alias) === needle),
    ) || null
  );
};
